import React from 'react';

export const LimelightActive = ({
  width = 18,
  height = 18,
  color = '#000',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 126 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M63 144C45.4125 144 30.5156 137.94 18.3094 125.82C6.10312 113.7 0 98.908 0 81.4447C0 66.3271 4.69219 51.6657 14.0766 37.4605C23.4609 23.2552 36.3562 11.1351 52.7625 1.10017C54.9937 -0.333387 57.2578 -0.365966 59.5547 1.00243C61.8516 2.37083 63 4.42343 63 7.16022V21.2352C63 25.6662 64.5422 29.3804 67.6266 32.3778C70.7109 35.3753 74.4844 36.874 78.9469 36.874C81.3094 36.874 83.5078 36.3853 85.5422 35.4079C87.5766 34.4304 89.3812 32.9643 90.9562 31.0094C92.0062 29.8365 93.1875 29.022 94.5 28.5659C95.8125 28.1097 97.0594 28.2726 98.2406 29.0546C106.903 34.9191 113.695 42.4779 118.617 51.7309C123.539 60.9839 126 70.8885 126 81.4447C126 98.908 119.897 113.7 107.691 125.82C95.4844 137.94 80.5875 144 63 144ZM11.8125 81.4447C11.8125 89.6551 13.6828 97.3767 17.4234 104.61C21.1641 111.843 26.3812 117.87 33.075 122.692C32.55 121.128 32.1563 119.532 31.8938 117.903C31.6313 116.274 31.5 114.677 31.5 113.113C31.5 108.943 32.2875 105.033 33.8625 101.384C35.4375 97.7351 37.7344 94.4119 40.7531 91.4144L55.9136 72.051C59.517 67.4486 66.483 67.4486 70.0864 72.051L85.2469 91.4144C88.2656 94.4119 90.5625 97.7351 92.1375 101.384C93.7125 105.033 94.5 108.943 94.5 113.113C94.5 114.677 94.3688 116.274 94.1063 117.903C93.8438 119.532 93.45 121.128 92.925 122.692C99.6187 117.87 104.836 111.843 108.577 104.61C112.317 97.3767 114.188 89.6551 114.188 81.4447C114.188 74.4072 112.678 67.5326 109.659 60.821C106.641 54.1093 102.309 47.9515 96.6656 42.3476C93.9094 44.3024 91.0219 45.8337 88.0031 46.9415C84.9844 48.0492 81.9656 48.6031 78.9469 48.6031C70.9406 48.6031 64.3125 45.8989 59.0625 40.4905C53.8125 35.0821 51.1875 28.2726 51.1875 20.0623V16.1525C39.1125 24.7539 29.5312 34.9517 22.4437 46.746C15.3562 58.5403 11.8125 70.1065 11.8125 81.4447Z"
      fill={color}
    />
  </svg>
);

<svg
  width="126"
  height="144"
  viewBox="0 0 126 144"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
></svg>;
